import http from '@/assets/common/http';
// 获取客户列表
export function customerList (data) {
  const params = {
    SERVICE_ID: '10005',
    OTYPE: 3,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 新增客户
export function addCustomer (data) {
  const params = {
    SERVICE_ID: '10005',
    OTYPE: 1,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 修改客户信息
export function editCustomer (data) {
  const params = {
    SERVICE_ID: '10005',
    OTYPE: 10,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 删除客户
export function deleteCustomer (data) {
  const params = {
    SERVICE_ID: '10005',
    OTYPE: 2,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 项目点列表
export function projectList (data) {
  const params = {
    SERVICE_ID: '10006',
    OTYPE: 5,
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 导出检测报告
export function exportCheckFun (data) {
  const params = {
    SERVICE_ID: '10006',
    OTYPE: 7,
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// -----------------------------------禁用项目点
export function stopProject (data) {
  const params = {
    SERVICE_ID: '10006',
    OTYPE: 2,
    ...data,
  };
  return http.post(params);
}


// -----------------------------------启用项目点
export function startProject (data) {
  const params = {
    SERVICE_ID: '10006',
    OTYPE: 6,
    ...data,
  };
  return http.post(params);
}


// -------------------------------------禁用客户
export function stopCustomerFun (data) {
  const params = {
    SERVICE_ID: '10005',
    OTYPE: 6,
    ...data,
  };
  return http.post(params);
}


// --------------------------------------启用客户
export function startCustomerFun (data) {
  const params = {
    SERVICE_ID: '10005',
    OTYPE: 7,
    ...data,
  };
  return http.post(params);
}


// 新增/修改项目点
export function addProject (data, OTYPE) {
  const params = {
    SERVICE_ID: '10006',
    OTYPE,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 获取档口
export function getDkList (data) {
  const params = {
    SERVICE_ID: '10007',
    OTYPE: 4,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 新增/修改档口
export function addDK (data, OTYPE) {
  const params = {
    SERVICE_ID: '10007',
    OTYPE,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// -------------------------自定义打印编码
export function printCODE (data) {
  const params = {
    SERVICE_ID: '10007',
    OTYPE: 6,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// -------------------------禁用档口
export function stopDK (data) {
  const params = {
    SERVICE_ID: '10007',
    OTYPE: 2,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// -------------------------启用档口
export function startDK (data) {
  const params = {
    SERVICE_ID: '10007',
    OTYPE: 5,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// -------------------------产品编码管理
export function tcCodeManage (data) {
  const params = {
    SERVICE_ID: '10203',
    OTYPE: 4,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 新增编码
export function matchCode (data) {
  const params = {
    SERVICE_ID: '10203',
    OTYPE: 1,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 解除匹配
export function deleteMatch (data) {
  const params = {
    SERVICE_ID: '10203',
    OTYPE: 2,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 修改编码
export function editCode (data) {
  const params = {
    SERVICE_ID: '10203',
    OTYPE: 3,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 导入编码
export function exportMatchCode (data) {
  const params = {
    SERVICE_ID: '10203',
    OTYPE: 5,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 供应商客户
export function supplierCusFun (data) {
  const params = {
    SERVICE_ID: '10001',
    OTYPE: 14,
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 绑定供应商
export function importCommodityFun (data) {
  const params = {
    SERVICE_ID: '10041',
    OTYPE: 24,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    PRICE_MODE: Number(sessionStorage.getItem('PRICE_MODE')),
    ...data,
  };
  return http.post(params);
}


// 导出产品
export function exportProductLists (data) {
  const params = {
    SERVICE_ID: '10041',
    OTYPE: 25,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 导出项目
export function exportProject (data) {
  const params = {
    SERVICE_ID: '10041',
    OTYPE: 26,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 导出档口
export function exportDK (data) {
  const params = {
    SERVICE_ID: '10041',
    OTYPE: 27,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 导入客户
export function importCustomer (data) {
  const params = {
    SERVICE_ID: '10041',
    OTYPE: 28,
    SUPPLIER_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 查看人员
export function queryPerson (data) {
  const params = {
    SERVICE_ID: '10173',
    OTYPE: 4,
    ...data,
  };
  return http.post(params);
}


export function addPerson (data) {
  const params = {
    SERVICE_ID: '10173',
    OTYPE: 1,
    ...data,
  };
  return http.post(params);
}


export function updatePerson (data) {
  const params = {
    SERVICE_ID: '10173',
    OTYPE: 3,
    ...data,
  };
  return http.post(params);
}


export function queryAllPerson (data) {
  const params = {
    SERVICE_ID: '10173',
    OTYPE: 10,
    ...data,
  };
  return http.post(params);
}


// 项目点及第三方供应商供货关系管理
export function getAllReleationFun (data) {
  const params = {
    SERVICE_ID: '10178',
    OTYPE: 4,
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 解除第三方供货关系
export function delReleationFun (data) {
  const params = {
    SERVICE_ID: '10178',
    OTYPE: 2,
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 新增第三方供货关系
export function addReleationFun (data) {
  const params = {
    SERVICE_ID: '10178',
    OTYPE: 1,
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 新增第三方供货关系
export function editReleationFun (data) {
  const params = {
    SERVICE_ID: '10178',
    OTYPE: 3,
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 拉去所有第三方供货商
export function getAllReleationSupplier (data) {
  const params = {
    SERVICE_ID: '10178',
    OTYPE: 5,
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 第三方供货产品管理
export function getproductReleationFun (data) {
  const params = {
    SERVICE_ID: '10178',
    OTYPE: 9,
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 一键同步所有产品
export function addAllProductReleationFun (data) {
  const params = {
    SERVICE_ID: '10178',
    OTYPE: 8,
    GYS_ID: sessionStorage.getItem('tcId'),
    PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
    ...data,
  };
  return http.post(params);
}


// 单个增加/修改
export function editProductReleationFun (data) {
  const params = {
    SERVICE_ID: '10178',
    OTYPE: 6,
    GYS_ID: sessionStorage.getItem('tcId'),
    PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
    ...data,
  };
  return http.post(params);
}


// 拉取全部可匹配产品
export function getCanMatchProduct (data) {
  const params = {
    SERVICE_ID: '10178',
    OTYPE: 13,
    GYS_ID: sessionStorage.getItem('tcId'),
    PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
    ...data,
  };
  return http.post(params);
}


// 批量导入产品
export function exportInProductFun (data) {
  const params = {
    SERVICE_ID: '10178',
    OTYPE: 12,
    GYS_ID: sessionStorage.getItem('tcId'),
    PRICE_MODE: sessionStorage.getItem('PRICE_MODE'),
    ...data,
  };
  return http.post(params);
}


// 批量接触匹配
export function exportOutProductFun (data) {
  const params = {
    SERVICE_ID: '10178',
    OTYPE: 11,
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 解除供应产品
export function delProductReleationFun (data) {
  const params = {
    SERVICE_ID: '10178',
    OTYPE: 7,
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}


// 导出所有供应产品
export function exportAllProductFun (data) {
  const params = {
    SERVICE_ID: '10178',
    OTYPE: 10,
    GYS_ID: sessionStorage.getItem('tcId'),
    ...data,
  };
  return http.post(params);
}

// 查询在用供应商企业列表（10001-90，按SUPPLIER_ID去重，仅保留SUPPLIER_ID和NAME）
export function queryActiveSupplierList (data) {
  const params = {
    SERVICE_ID: '10001',
    OTYPE: 90,
    GYS_ID: Number(sessionStorage.getItem('tcId')),
    ...data,
  };
  return http.post(params).then((result) => {
    if (result && result.length && result[0].list) {
      const list = result[0].list;
      const uniqueMap = {};
      list.forEach((item) => {
        uniqueMap[item.SUPPLIER_ID] = { SUPPLIER_ID: item.SUPPLIER_ID, NAME: item.NAME };
      });
      return Object.values(uniqueMap);
    }
    return [];
  });
}





// WEBPACK FOOTER //
// ./src/assets/api/customerManage.js